import type { InjectionKey } from 'vue'

export const DISABLE_MENU_LOGO_LINK_KEY: InjectionKey<boolean> = Symbol('disableMenuLogoLink')
